<template>
<div class="hot-page" v-loading="pageLoading">
  <van-nav-bar ref="nav" :border="false" @click-left="back" placeholder :fixed="true" :title="name">
    <template #left>
      <van-icon size="20px" name="arrow-left" color="#333" />
    </template>
  </van-nav-bar>
  <div class="hot-video">
    <div class="video player" id="player"></div>

  </div>
  <div class="video-name">
    <p v-if="host">{{ host }}</p>
    <p v-if="category_name">{{ category_name }}</p>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  computed: {
    partalName() {
      return this.$store.state.partal.name;
    },
  },
  data() {
    return {
      name: '',
      url: '',
      host: '',
      category_name: '',
      cover: '',
      pageLoading: false,
      players: '',
    };
  },
  destroyed() {
    // for (var i = 0; i < this.list.length; i++) {
    //   let vid = this.list[i];
    //   this.players[vid] && this.players[vid].destroy();
    // }
  },
  async mounted() {
    let {
      url,
      name,
      host,
      cover,
      category_name,
      id,
      videoId,
      type
    } = this.$route.query;
    // this.url = url || '';
    this.url = 'https://tuoyufuwu.obs.cn-north-4.myhuaweicloud.com/web/informationCollection/1698627535311_lv_0_20231030065045.mp4'
    this.name = name || '';
    this.host = host || '';
    this.cover = cover || '';
    this.category_name = category_name || '';
    if(id){
      this.$api({
        method: "get",
        url: "/api/livestream/click",
        data: {
          id,
        },
      });
    }
    console.log('ulr:',url)
    if (url) {
      console.log(this.url)
      this.player = new Aliplayer({
          id: 'player',
          width: "100%",
          height: "100%",
          source: this.url,
          cover: this.cover,
          skinLayout: [{
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0
            },
            {
              name: "infoDisplay"
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56
            },
            {
              name: "thumbnail"
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [{
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12
                },
                {
                  name: "subtitle",
                  align: "tr",
                  x: 15,
                  y: 12
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 5,
                  y: 10
                },
              ],
            },
          ],
        },
        function (player) {
          console.log("The player is created.");
        }
      );
    } else {
      if (type == 'aliyun') {
        let vid = videoId;
        let res = await this.$api({
          url: "/api/video/play-auth/get",
          data: {
            video_id: vid,
          },
        });
        if (res.code == 0) {
          if (this.player) {
            this.player.dispose();
          }
          this.player = new Aliplayer({
              id: "player",
              width: "100%",
              height: "100%",
              vid: res.data.videoId,
              playauth: res.data.playAuth,
            },
            function (player) {
              console.log("The player is created.");
            }
          );
        }
      } else {
        this.player = window.createCCH5Player({
          vid: videoId,
          siteid: "23EEB4513490D389",
          autoStart: true,
          playertype: 1,
          isShare: "false",
          banDrag: "false",
          width: "100%",
          height: "100%",
          loop: "true",
          showFullScreenBtn: "false",
          useX5Play: "true",
          isShowUrlBtn: "false",
          isShowMoreBtn: "false",
          objectFit: "cover", // contain 、 fill 、 cover
          parentNode: ".video",
        });
      }
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.hot-page {
  min-height: 100vh;
  overflow: hidden;
  background: #000;
}

.hot-video {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-top: 40vh;
  transform: translateY(-50%);
}

.hot-page .video-name {
  position: fixed;
  bottom: 50px;
  left: 0;
  padding: 20px 30px 19px;
  color: #fff;
  font-size: 32px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  font-weight: 500;
  letter-spacing: 1px;
}

.video-name p {
  line-height: 1.8;
}

.hot-page .video {
  width: 100%;
  min-height: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #000;
}

.hot-page .video>.cover {
  width: 100%;
}

.hot-page .video>.play {
  width: 85px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.hot-page .video-msg {
  position: absolute;
  bottom: 80px;
  left: 0;
  overflow: hidden;
  color: #fff;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  padding: 20px 30px;
  box-sizing: border-box;
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/hotKeyInnerBg.png") no-repeat center;
  background-size: 100%;
  z-index: 998;
}

.hot-page .video-lesson {
  color: #666;
  font-size: 28px;
  height: 80px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  background: #fff;
  width: 100%;
}
</style>
